export default "__VITE_ASSET__cdbfdcd3__"